// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import { QuestRoute } from './api/QuestRoutes';
import { useGlobalState } from './globalState/GlobalStateProvider';
import Loading from './Loading';
import { HamQuest } from '../../App';
import Modal from './Modal';
import { UseDeviceId } from './api/usePersistedState';

const PaymentForm = ({ socketId, amount, ...props }) => {
    const {
        state: {
            active_user
        },
    } = useGlobalState();

    const [formData, setFormData] = useState(null);
    const [processor, setProcessor] = useState(null);

    useEffect(() => {
        const fetchPaymentForm = async () => {
            HamQuest.getQuery(QuestRoute.paymentForm.setup, {
                socketId: socketId
            }, {
                captcha: window.siteKey,
                headers: {
                    deviceId: await UseDeviceId()
                },
            })
                .then(res => {
                    setProcessor(res.processor)
                    setFormData(res.setupData)
                })
                .catch(ex => Modal.Show({
                    title: 'Error',
                    body: ex.blob
                }))
        }
        fetchPaymentForm()
    }, [])

    if (!active_user.account.emailConfirmed) return;
    if (!active_user.isLoggedIn) return;
    if (!processor) return <Loading />;

    switch (processor.toLowerCase()) {
        case 'exacthosted':
            return <ExactForm formData={formData} />
        case 'worldpay':
            return <WorldPayForm formData={formData} />
        case 'ips':
            return <IPSForm formData={formData} />
        case 'moneris':
            return <MonerisForm formData={formData} socketId={socketId} />
        case 'moneris_deprecated':
            return <MonerisDeprecated formData={formData} socketId={socketId} />
        default:
            return <div>No Payment processor!</div>
    }
}

export default PaymentForm;

// IPS ///////////////////////////////////////////////////////////////////////////////////////////////////////
const IPS = styled.iframe`
    height: 450px;
    min-width: 340px;
    width: 100%;
    border: 0px;
    background: ${({ theme }) => theme.mobile.white};
    border-radius: 0.2rem;
    font-size: 0.9em;
    overflow: hidden;
`;
const IPSForm = ({ formData, ...props }) => {
    return (
        <>
            <IPS src={formData?.form_url} />
        </>
    )
};

// WORLDPAY ///////////////////////////////////////////////////////////////////////////////////////////////////////
const WorldPay = styled.iframe`
    height: 450px;
    min-width: 340px;
    width: 100%;
    border: 0px;
    background: ${({ theme }) => theme.mobile.white};
    border-radius: 0.2rem;
    font-size: 0.9em;
    overflow: hidden;
`;
const Tag = styled.span`
    font-size: 0.5em;
    line-height: 1.2em;
`;
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;
const WorldPayForm = ({ formData, ...props }) => {
    return (
        <>
            <WorldPay src={formData?.form_url} />
        </>
    )
};

// EXACT ///////////////////////////////////////////////////////////////////////////////////////////////////////
const Exact = styled.form`
    display: flex;
    flex-grow: 1;
    height: 420px;
    background: ${({ theme }) => theme.mobile.white};
`
const ExactForm = ({ formData, ...props }) => {
    useEffect(() => {
        if (!formData) return;
        document.getElementById('exactHostedForm').submit()
    }, [formData])

    return (
        // <Exact action='https://checkout.e-xact.com/pay' method="post" target="ExactEmbeddedFrame" id="exactHostedForm">
        <Exact action='https://rpm.demo.e-xact.com/payment' method="post" target="ExactEmbeddedFrame" id="exactHostedForm">
            <input name="x_login" value={formData?.x_login} type="hidden" />
            <input name="x_amount" value={formData?.x_amount} type="hidden" />
            <input name="x_fp_sequence" value={formData?.x_fp_sequence} type="hidden" />
            <input name="x_fp_timestamp" value={formData?.x_fp_timestamp} type="hidden" />
            <input name="x_fp_hash" value={formData?.x_fp_hash} type="hidden" />
            <input name="x_currency_code" value={formData?.x_currency_code} type="hidden" />
            <input name="x_show_form" value="PAYMENT_FORM" type="hidden" />
            <input name="x_test_request" value={formData?.x_test_request} type="hidden" />
            <input name="x_type" value={formData?.x_type} type="hidden" />
            <input name="x_po_num" value={formData?.x_po_num} type="hidden" />
            <input name="x_receipt_link_method" value="AUTO-POST" type="hidden" />
            <input name="x_receipt_link_url" value={formData?.x_receipt_link_url} type="hidden" />
            <iframe
                id='ExactEmbeddedFrame'
                name='ExactEmbeddedFrame'
                title='ExactForm'
                style={{ width: '100%' }}
            />
        </Exact>
    )
}

// MONERIS ///////////////////////////////////////////////////////////////////////////////////////////////////////
const Moneris = styled.form`
    display: flex;
    flex-grow: 1;
    height: 600px;
    background: ${({ theme }) => theme.mobile.white};
`
const MonerisDeprecated = ({ formData, socketId, ...props }) => {
    const {
        state: {
            mobile_view,
        },
    } = useGlobalState();

    useEffect(() => {
        if (!formData) return;
        document.getElementById('monerisHostedForm').submit();
    }, [formData])

    return (
        <Moneris action="https://esqa.moneris.com/HPPDP/index.php" method="post" target="MonerisEmbeddedFrame" id="monerisHostedForm">
            <input value={formData?.storeId} name="ps_store_id" type="hidden" />
            <input value={formData?.hppKey} name="hpp_key" type="hidden" />
            <input value={formData?.amount} name="charge_total" type="hidden" />
            <input value={formData?.refNum} name="order_id" type="hidden" />
            <input value={socketId} name="note" type="hidden" />
            <input value="True" name="rvar_test_account" type="hidden" />
            <iframe
                name="MonerisEmbeddedFrame"
                id="MonerisEmbeddedFrame"
                title='MonerisForm'
                style={{ width: mobile_view ? '100%' : '660px' }}
            />
        </Moneris>
    )
}

const MonerisNEW = styled.div`
    position: relative !important;
    display: flex !important;
    justify-content: center !important;
    flex-direction: column !important;
    align-items: center !important;
    flex-grow: 1;
    height: 600px !important;
    //width: 500px !important;
    background: ${({ theme }) => theme.mobile.white};
`
const MonerisForm = ({ formData, socketId, ...props }) => {
    window.socketId = socketId;
    useLayoutEffect(() => {
        const script = document.createElement('script');
        script.src = process.env.REACT_APP_MONERIS;
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            const myCheckout = new window.monerisCheckout();
            myCheckout.setCheckoutDiv('monerisCheckout');
            myCheckout.setMode(formData.isTestAccount ? 'qa' : 'prod');
            myCheckout.setCallback('payment_receipt', onPaymentReceipt);
            myCheckout.startCheckout(formData.ticket);

            function onPaymentReceipt(res) {
                if (window.socketId !== socketId) return;
                try {
                    res = JSON.parse(res);
                    HamQuest.getQuery('/payments/moneris/receipts', {
                        ticket: res.ticket,
                        socketId: socketId
                    })
                } catch (ex) {
                    console.log(ex)
                }
            }
        };

        return () => document.body.removeChild(script);
    }, [])

    return <MonerisNEW id='monerisCheckout' />;
}